export function convertFencedBlocksForRead(html) {
  if (!html) return html;

  // Normalize editor artifacts (so fences are contiguous)
  let work = String(html)
    .replace(/&nbsp;/gi, ' ')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div)>\s*<(p|div)[^>]*>/gi, '\n\n')
    .replace(/\n{3,}/g, '\n\n');

  // Detect ``` fences even if editor added extra <div>, <p>, or <br>
  const fenceRegex = /```(\w+)?[\n\r]+([\s\S]*?)```/g; // supports embedded newlines and tags

  const stripTags = (s) => s.replace(/<[^>]*>/g, '');

  const escapeHtml = (s) =>
    s
      .replace(/&(?!lt;|gt;|amp;)/g, '&amp;') // don’t double-escape
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

  // Replace all fenced blocks
  work = work.replace(fenceRegex, (_match, lang, body) => {
    const language = (lang || 'plain').trim();
    const codeText = stripTags(body.trim());
    const escaped = escapeHtml(codeText);
    return `<pre><code class="language-${language}">${escaped}</code></pre>`;
  });

  return work;
}
